import React, { FC, useEffect, useState } from 'react';
import { InjectedFormikProps } from 'formik';
import { useParams } from 'react-router-dom';

import { IRequesterFormElementsValues } from '../common/RequesterFormElements';
import { fetchRequestereByIdAPI, IRequester } from 'src/services/api/frontLine';
import EditRequesterForm from './form';

const EditRequester: FC<InjectedFormikProps<
  {},
  IRequesterFormElementsValues
>> = props => {
  const { id = '' } = useParams();
  const [isLoaded, setIsLoaded] = useState(false);
  const [formData, setFormData] = useState<IRequester>({} as IRequester);

  useEffect(() => {
    (async () => {
      try {
        const response = await fetchRequestereByIdAPI(id);
        console.log(response);
        setFormData(response);
        setIsLoaded(true);
      } catch (e) {
        throw e;
      }
    })();
  }, []);

  return (
    <div className="container">
      <h4 className="text-center" style={{ margin: '20px' }}>
        Update Requester
      </h4>
      {isLoaded ? (
        <EditRequesterForm {...props} requester={formData} />
      ) : (
        <p className="text-center">Loading...</p>
      )}
    </div>
  );
};

export default EditRequester;
